export interface ISheetDates {
    balanceCurrentYearDate: Date;
    balancePreviousYearDate: Date;
    incomeCurrentYearFromDate: Date;
    incomeCurrentYearToDate: Date;
    incomePreviousYearFromDate: Date;
    incomePreviousYearToDate: Date;
}
